/* wg-product-care-tabs.js - Wade Greens
   Moves the blocks rendered by sections/wg-product-care.liquid into the
   product's existing tab strip, so Pest Watch reads as a tab alongside
   Description / Specifications / Care Instructions / Growing Zone /
   Questions & Answers / Shipping & Returns.

   WHY THIS IS JAVASCRIPT AND NOT LIQUID
   The tabs are emitted by sections/main-product.liquid, which is 140,885 bytes.
   The Admin API writes whole files and ~40KB is the proven ceiling, so that
   file cannot be edited through the API at all - only by hand in Shopify's
   code editor. Rather than hand Devyn a paste job into a 140KB file, the
   content is rendered server-side by our own section (so it is in the HTML for
   crawlers and works with JS off) and then relocated into the tab strip here.

   WHY IT BUILDS AN HTML STRING INSTEAD OF createElement
   <product-tab> is a registered custom element. Creating it with
   createElement() upgrades it immediately, so its connectedCallback can run
   before the toggle markup exists inside it and the tab never wires up.
   insertAdjacentHTML parses the whole node with its children in place, so the
   element upgrades complete and the theme's own toggle takes over.

   The source section is HIDDEN, never removed: its <style> block is a sibling
   of the <section>, so removing the section would take the CSS with it and the
   relocated content would lose its formatting.
*/
(function () {
  'use strict';

  function slugify(s) {
    return 'tab-wg-' + s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function init() {
    var src = document.querySelector('.wg-pdp');
    var host = document.querySelector('.container.product-tabs');
    if (!src || !host) return;

    var blocks = src.querySelectorAll('.wg-pdp__block');
    if (!blocks.length) return;

    // reuse the theme's own chevron so the new tabs are visually identical
    var chevronEl = host.querySelector('.icon-dropdown');
    var chevron = chevronEl ? chevronEl.innerHTML : '';

    var existing = host.querySelectorAll('product-tab');
    var anchor = existing.length ? existing[existing.length - 1] : null;
    var added = [];

    Array.prototype.forEach.call(blocks, function (block) {
      var h = block.querySelector('.wg-pdp__h');
      if (!h) return;
      var title = h.textContent.trim();
      var slug = slugify(title);

      // drop the heading and its rule - the tab's own title bar replaces them
      h.parentNode.removeChild(h);
      var rule = block.querySelector('.wg-pdp__rule');
      if (rule) rule.parentNode.removeChild(rule);

      var html =
        '<product-tab class="productView-tab layout-vertical halo-product-tab" data-vertical="false" data-vertical-mobile="">' +
          '<div class="tabs-contents tabs-contents-vertical clearfix halo-text-format">' +
            '<div class="tab-content wg-pdp-tab" id="' + esc(slug) + '">' +
              '<div class="toggle-title">' +
                '<a class="toggleLink" data-collapsible="" href="#' + esc(slug) + '-mobile">' +
                  '<span class="text">' + esc(title) + '</span>' +
                  '<span class="icon-dropdown">' + chevron + '</span>' +
                '</a>' +
              '</div>' +
              '<div class="toggle-content" id="' + esc(slug) + '-mobile">' + block.innerHTML + '</div>' +
            '</div>' +
          '</div>' +
        '</product-tab>';

      if (anchor) {
        anchor.insertAdjacentHTML('afterend', html);
        anchor = anchor.nextElementSibling;
      } else {
        host.insertAdjacentHTML('beforeend', html);
        anchor = host.querySelector('product-tab:last-of-type');
      }
      if (anchor) added.push(anchor);
    });

    if (!added.length) return;

    // the section is hidden, not removed - its <style> sibling carries the CSS
    src.style.display = 'none';

    // Fallback: if the theme's custom element did not collapse the new tabs,
    // wire a toggle so they never sit permanently open.
    setTimeout(function () {
      added.forEach(function (pt) {
        var content = pt.querySelector('.toggle-content');
        var link = pt.querySelector('a.toggleLink');
        if (!content || !link) return;
        if (window.getComputedStyle(content).display !== 'none') {
          content.style.display = 'none';
          link.addEventListener('click', function (e) {
            e.preventDefault();
            var open = content.style.display !== 'none';
            content.style.display = open ? 'none' : 'block';
            pt.querySelector('.tab-content').classList.toggle('is-open', !open);
          });
        }
      });
    }, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();